export const CURRENCY = "$";
export var recordsLimit = 10;
export var recordsLimit50 = 50;
export const googleMapApiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

export const allowedFileTypes = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "image/*": [".png", ".jpeg", ".jpg"],
};

export const allowedImageTypes = {
  "image/*": [".png", ".jpeg", ".jpg", ".jfif", ".webp"],
};

// permission route
export const permissionRoute = {
  "/": "dashboard",
  "/user-management": "user-management",
  "/role-management": "role-management",
  "/staff-management": "staff-management",
  "/cms": "cms",
  "/crud": "crud",
  "/contact-management": "contact-us",
  "/order-management": "order-management",
  "/reports-analytics": "reports-analytics",
  "/inventory-management": "inventory-management",
  "/royalty-program": "royalty-program",
  "/system-config": "system-config",
  "/shipment-method": "crud",
  "/warehouse-management": "warehouse-management",
  "/brand-management": "brand-management",
  "/category-management": "category-management",
  "/promotions-management": "promotions-management",
};
export const notProtectedRoute = [
  "/login",
  "/profile-settings",
  "/notifications",
  "/",
];
